import React, {useContext, useEffect, useState} from 'react';
import renderHTML from 'react-render-html';

import { ErrorContext } from '../utils/constants';
import { getBinary } from '../utils/apiUtils';

export default function KnowledgeBase()  {
  const { triggerError } = useContext(ErrorContext);
  const [ html, setHtml ] = useState('<div />');

  const onError = () => triggerError({
    title: 'Communication Error',
    description: 'We were unable to read knowledge base from the server. Please try again.',
    onRetry: () => window.location.reload(),
  });

  useEffect(() => {
    document.title = 'Rise by TransAlta Knowledge Base';
  }, []);

  useEffect(() => {
    getBinary('/rise_knowledge_base.html', 'GET', '', async (fileContent) => {
      const html = await fileContent.text();
      setHtml(html);
    }, onError);
  }, []);

  return (
    <div>
      {renderHTML(html)}
    </div>
  );
}
